import { render } from "./FileIcon.vue?vue&type=template&id=581021a8"
import script from "./FileIcon.vue?vue&type=script&lang=js"
export * from "./FileIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__